// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","logo":"styles_logo__hTa5C","navigation":"styles_navigation__7OI4X"};